 const Unsubscribe = lazy(() => import("./pages/newsletter/Unsubscribe"));
                 <Route path="/newsletter/unsubscribe" element={<Unsubscribe />} />
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthProvider } from "@/contexts/AuthContext";
import { AnalyticsProvider } from "@/components/analytics/AnalyticsProvider";
import { I18nProvider } from "@/contexts/I18nContext";
 import { ProtectedRoute, AdminRoute, ModeratorRoute, SuperAdminRoute } from "@/components/auth/ProtectedRoute";
import { InactivityGuard } from "@/components/auth/InactivityGuard";

// Eagerly loaded — critical for FCP / SSG entry points
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

// Lazy: non-critical, only renders for users without saved cookie prefs.
const CookieBanner = lazy(() => import("@/components/gdpr/CookieBanner"));

// Lazy-loaded heavy / less-critical routes (code-splitting)
const Search = lazy(() => import("./pages/Search"));
const ScooterDetail = lazy(() => import("./pages/ScooterDetail"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Publish = lazy(() => import("./pages/Publish"));
const EditListing = lazy(() => import("./pages/EditListing"));
const Profile = lazy(() => import("./pages/Profile"));
const MyListings = lazy(() => import("./pages/MyListings"));
const Favorites = lazy(() => import("./pages/Favorites"));
const Admin = lazy(() => import("./pages/Admin"));
const AnalyticsDebug = lazy(() => import("./pages/AnalyticsDebug"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const LegalNotice = lazy(() => import("./pages/LegalNotice"));
const Contact = lazy(() => import("./pages/Contact"));
const Messages = lazy(() => import("./pages/Messages"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const PaymentCancel = lazy(() => import("./pages/PaymentCancel"));
const SEODebug = lazy(() => import("./pages/SEODebug"));
const Comparator = lazy(() => import("./pages/Comparator"));
const BuyingGuide = lazy(() => import("./pages/BuyingGuide"));
const SavingsCalculator = lazy(() => import("./pages/SavingsCalculator"));
const MyOrders = lazy(() => import("./pages/MyOrders"));
const MySales = lazy(() => import("./pages/MySales"));
 const MyAlerts = lazy(() => import("./pages/MyAlerts"));
 const Unauthorized = lazy(() => import("./pages/Unauthorized"));

const queryClient = new QueryClient();

const RouteFallback = () => (
  <div className="flex min-h-[50vh] items-center justify-center" aria-label="Cargando página" />
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <AnalyticsProvider>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/buscar" element={<Search />} />
                <Route path="/patinete/:slug" element={<ScooterDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/registro" element={<Register />} />
                <Route path="/recuperar" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/publicar" element={<ProtectedRoute><Publish /></ProtectedRoute>} />
                <Route path="/editar-anuncio/:id" element={<ProtectedRoute><EditListing /></ProtectedRoute>} />
                <Route path="/perfil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/mis-anuncios" element={<ProtectedRoute><MyListings /></ProtectedRoute>} />
                <Route path="/favoritos" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
                <Route path="/mensajes" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                <Route path="/mis-pedidos" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
                <Route path="/mis-ventas" element={<ProtectedRoute><MySales /></ProtectedRoute>} />
                <Route path="/mis-alertas" element={<ProtectedRoute><MyAlerts /></ProtectedRoute>} />
                <Route path="/admin" element={<ModeratorRoute><Admin /></ModeratorRoute>} />
                 <Route path="/admin/analytics-debug" element={<SuperAdminRoute><AnalyticsDebug /></SuperAdminRoute>} />
                 <Route path="/admin/seo-debug" element={<SuperAdminRoute><SEODebug /></SuperAdminRoute>} />
                <Route path="/comparador" element={<Comparator />} />
                <Route path="/guia-compra" element={<BuyingGuide />} />
                <Route path="/calculadora" element={<SavingsCalculator />} />
                <Route path="/privacidad" element={<Privacy />} />
                <Route path="/terminos" element={<Terms />} />
                <Route path="/aviso-legal" element={<LegalNotice />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/pago-exitoso" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
                 <Route path="/pago-cancelado" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
                 <Route path="/403" element={<Unauthorized />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
            <InactivityGuard />
            <Suspense fallback={null}>
              <CookieBanner />
            </Suspense>
          </AnalyticsProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
